import { ApiNewDokumentPowiazanyDalDto, EgibObject } from '@gk/gk-modules';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { WorkspaceState } from '../../../../services/request-workspace-state/request-workspace-state.model';
import {
  DocumentationFormType,
  ExtendedApplicantRequest,
  ExtendedApplicantRequestDto,
} from '../../../../shared/base-new-request/base-new-request.model';
import {
  InvestorDetails,
  InvestorDetailsRequestDto,
} from '../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';
import { DateHelperUtil } from '../../../../utils/date-helper/date-helper.util';
import {
  Shrub,
  ShrubRequestDto,
  Tree,
  TreeRequestDto,
} from '../../../environmental-protection-portal/trees-and-shrubs-felling-request/services/new-request/new-request.model';

export interface TSFWDRNewRequestDto extends ExtendedApplicantRequestDto {
  Wlasciciele: InvestorDetailsRequestDto[];
  WlascicielSameAsWnioskodawca: boolean;
  Drzewa: TreeRequestDto[];
  Krzewy: ShrubRequestDto[];
  PrzyczynaUsuniecia: string;
  PlanowanyTermin: string;
}

export class TSFWDRNewRequest extends ExtendedApplicantRequest {
  constructor(
    investorDetails: InvestorDetails,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    proxyDetailsCheckbox: boolean,
    proxyDetailsArray: InvestorDetails[],
    public owners: InvestorDetails[],
    public ownerOtherThanApplicant: boolean,
    public trees: Tree[],
    public shrubs: Shrub[],
    public removalReason: string,
    public plannedDate: NgbDate,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      proxyDetailsCheckbox,
      proxyDetailsArray,
    );
  }

  static fromAppToApi(
    data: TSFWDRNewRequest,
    parcels: EgibObject[],
    issueRanges: string[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): TSFWDRNewRequestDto {
    return {
      ...ExtendedApplicantRequest.mapCommonFields({
        data,
        files,
        parcels,
        issueRanges,
      }),
      Wlasciciele: data.owners?.map((owner) =>
        InvestorDetailsRequestDto.fromAppToApi(owner),
      ),
      WlascicielSameAsWnioskodawca: !data.ownerOtherThanApplicant,
      Drzewa: data.trees.map((tree) => TreeRequestDto.fromApiToApp(tree)),
      Krzewy: data.shrubs.map((shrub) => ShrubRequestDto.fromApiToApp(shrub)),
      PrzyczynaUsuniecia: data.removalReason,
      PlanowanyTermin: DateHelperUtil.ngbDateToApiDateTime(data.plannedDate),
    };
  }
}

export interface TSFWDRNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: TSFWDRNewRequest;
  parcels: EgibObject[];
  issueRanges: string[];
}
